
const authentication  = {
     "111111" : "b9d90a65bc4344b0c4bb2146e0932db6",  //Barra Bonita
     "222222"  : "96e79218965eb72c92a549dd5a330112", //Apresentacao
     "2127881"  : "fd9d0255325ff1af4c9af464670d682e",
     "9639659" : "9ed30eea08295bd4e2ec3483b4d9dba5",
     "2091267" : "a1ff4eb409916af1092d520afd499408", //Santa Rita
     "2790653" : "55289ea4910321f362b9ed32126f707a",
     "2747693" : "ab7c007717e7c6312964aebef333bc60", //Ribeirão Bonito
     "2745801" : "bb4441c7f14e10d6205a8505cd4bda46", //Morro Agudo
     "2082632" : "b6b4b25fac3a95c7949184752d5aa587",
     "5288541" : "b9d90a65bc4344b0c4bb2146e0932db6",
     "2127695" : "4b6e336e3d9b0093278d19a2157a5537",
     "2081717" : "1d82d0e735461dae86fc0336f56a1f87", //Descalvado
     "2747685" : "644295992f8b15ac3bab452649794062", //Nova Europa
     "2079399" : "3e1d76ad25754f465eaa2aee1b930055"
}

export default authentication;
